import { render, staticRenderFns } from "./JsonTextArea.vue?vue&type=template&id=288c94fb&"
import script from "./JsonTextArea.vue?vue&type=script&lang=js&"
export * from "./JsonTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports